export type EventType = "exchange" | "salesmeeting" | "showing";

export const EXCHANGE = "exchange";
